import { CreateIconArguments } from '##/icons/Icon/helpers';

import IconToolsInclineSizeS from './IconToolsIncline_size_s';

const props: CreateIconArguments = {
  l: IconToolsInclineSizeS,
  m: IconToolsInclineSizeS,
  s: IconToolsInclineSizeS,
  xs: IconToolsInclineSizeS,
  name: 'IconToolsIncline',
  renderType: { l: 'use', m: 'use', s: 'use', xs: 'use' },
  color: 'multiple',
};

export default props;
